module.exports = __webpack_public_path__ + "img/privacy-mode-icon.bed79577.webp";